
import React, { PureComponent } from 'react';

import { Dialog } from '../../base/dialog';
import { translate } from '../../base/i18n';
import { Lozenge } from '../../base/react';

/**
 * The type of the React {@code Component} props of
 * {@link KeyboardShortcutsDialog}.
 */
type Props = {

    /**
     * A Map with keyboard keys as keys and translation keys as values.
     */
    shortcutDescriptions: Object,

    /**
     * Invoked to obtain translated strings.
     */
    t: Function
};

/**
 * Implements a React {@link Component} which displays a dialog describing
 * registered keyboard shortcuts.
 *
 * @augments Component
 */
class KeyboardShortcutsDialog extends PureComponent<Props> {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const shortcuts = Array.from(this.props.shortcutDescriptions)
            .map(description => this._renderShortcutsListItem(...description));

        return (
            <Dialog
                cancelKey = { 'dialog.close' }
                submitDisabled = { true }
                titleKey = 'keyboardShortcuts.keyboardShortcuts'
                width = 'small'>
                <div
                    id = 'keyboard-shortcuts'>
                    <ul
                        className = 'shortcuts-list'
                        id = 'keyboard-shortcuts-list'>
                        { shortcuts }
                    </ul>
                </div>
            </Dialog>
        );
    }

    /**
     * Creates a {@code ReactElement} for describing a single keyboard shortcut.
     *
     * @param {string} keyboardKey - The keyboard key that triggers an action.
     * @param {string} translationKey - A description of what the action does.
     * @private
     * @returns {ReactElement}
     */
    _renderShortcutsListItem(keyboardKey, translationKey) {

        const randomHue = Math.floor(Math.random() * 360);
        const saturation = 68.2;
        const saturationborder = 51;
        const lightness = 91.4;
        const darkness = 61;
        const color = `hsl(${randomHue}, ${saturation}%, ${lightness}%)`;
        const boderColor = `hsl(${randomHue}, ${saturationborder}%, ${darkness}%)`;


        const itemactionstyle = {
            background: color,
            borderRadius: '5px'
        };

        const shortcutsstyle = {
            border: `1px solid ${boderColor}`
        };

        return (
            <li
                className = 'shortcuts-list__item'
                key = { keyboardKey }
                style = { shortcutsstyle }>
                <span className = 'shortcuts-list__description'>
                    { this.props.t(translationKey) }
                </span>
                <span
                    className = 'item-action'
                    style = { itemactionstyle }>
                    <Lozenge isBold = { true }>
                        { keyboardKey }
                    </Lozenge>
                </span>
            </li>
        );
    }
}

export default translate(KeyboardShortcutsDialog);
